import { Branch, WorldAssignment, NetworkInstance, WorldAssignmentFacade } from "@goodgamestudios/world-assignment";

export class BranchesModel {
    public branchByZoneId(zoneId: string): Branch {
        // return (window.ggs.worldAssignment as WorldAssignment).facade.getBranchByZoneId(zoneId) || new Branch("TEMP_DEFAULT");
        // TODO HTML5 check in case of no zone found if we need to    return this._defaultBranch;
        return (window.ggs.worldAssignment as WorldAssignment).facade.getBranchByZoneId(zoneId);
    }


    public get currentBranch(): Branch {
        return (window.ggs.worldAssignment as WorldAssignment).facade.currentBranch;
    }

}


const compareBranches = (facade: WorldAssignmentFacade, zone: string) => {
    // this madness was inside SelectServerBox
    // let newBranchIsDefaultBranch:boolean = currentBranch.id == "default";
    // let instanceIsTestInstance:boolean = instanceOfClass(instance, "TestInstanceVO") || instance.zone.indexOf("Test") > 0;
    // let selectedInstanceIsTestInstance:boolean = instanceOfClass(currentlySelectedInstance, "TestInstanceVO") || instance.zone.indexOf("Test") > 0;
    //    if (bm && ((branchByZone == null) != newBranchIsDefaultBranch) && branchByZone != currentBranch && !instanceIsTestInstance && !selectedInstanceIsTestInstance) --->  RELOAD
    const currentBranch = facade.currentBranch;
    const newBranch = facade.getBranchByZoneId(zone);
    return newBranch && newBranch != currentBranch;
}


export const shouldReloadBranch = (instance: NetworkInstance) => compareBranches((window.ggs.worldAssignment as WorldAssignment).facade, instance.zoneId.toString());